<template>
  <div class="outer">
    <!-- Dialog -->
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs6>
                <v-switch
                  :label="`Listing Active?: ${editedItem.active ? 'Yes' : 'No'}`"
                  v-model="editedItem.active"
                ></v-switch>
              </v-flex>

              <v-flex xs6>
                <v-select
                  v-model="editedItem.type"
                  :items="types"
                  item-text="label"
                  item-value="key"
                  label="Commitment Type"
                ></v-select>
              </v-flex>

              <v-flex
                xs12
                md8
              >
                <v-text-field
                  v-model="editedItem.title"
                  label="Title"
                  :rules="[rules.required]"
                  counter="100"
                  max="100"
                ></v-text-field>
              </v-flex>

              <v-flex
                xs12
                md4
              >
                <v-text-field
                  v-model="editedItem.id"
                  label="Career ID / URL"
                  :rules="[rules.required]"
                  counter="20"
                  max="20"
                  hint="Used for URL: No special characters, No space. Hiphen (-) instead of space"
                  persistent-hint
                ></v-text-field>
              </v-flex>

              <v-flex xs12>
                <v-text-field
                  v-model="editedItem.role"
                  label="Role"
                  :rules="[rules.required]"
                  counter="100"
                  max="100"
                ></v-text-field>
              </v-flex>

              <v-flex xs12>
                <markdown-editor
                  v-model="editedItem.details"
                  :configs="editorConfigs"
                ></markdown-editor>
              </v-flex>

              <v-flex xs12>
                <v-spacer></v-spacer>
                <v-btn
                  color="accent "
                  @click.native="save "
                >Save</v-btn>
                <v-btn
                  color=" "
                  @click.native="close "
                >Cancel</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-card height="100%">
      <v-card-title class="title">Careers
        <v-spacer></v-spacer>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="careerList"
        hide-actions
      >
        <template
          slot="items"
          slot-scope="props "
        >
          <td class="text-xs-left">{{ props.item.title }}</td>
          <td class="text-xs-left">{{ props.item.role }}</td>
          <td class="text-xs-left">{{ props.item.type === 'job' ? 'Paid Job' : 'Volunteering' }}</td>
          <td class="text-xs-center">{{ props.item.active? 'Yes' : 'No'}}</td>
          <td class="justify-center layout px-0">
            <v-btn
              icon
              class="mx-0"
              @click="editItem(props.item) "
            >
              <v-icon color="info ">edit</v-icon>
            </v-btn>
            <v-btn
              icon
              class="mx-0"
              @click="deleteItem(props.item) "
            >
              <v-icon color="error ">delete</v-icon>
            </v-btn>
          </td>
        </template>
        <template slot="no-data ">Loading Data...</template>
      </v-data-table>

      <v-btn
        fab
        bottom
        left
        fixed
        color="accent "
        @click.stop="dialog=! dialog "
      >
        <v-icon>add</v-icon>
      </v-btn>
    </v-card>
  </div>
</template>


<script>
import marked from "marked";
export default {
  data: () => ({
    dialog: false,

    headers: [
      {
        text: "Title",
        value: "title",
        align: "left"
      },
      {
        text: "Role",
        value: "role",
        align: "left"
      },
      {
        text: "Type",
        value: "type"
      },

      {
        text: "Active?",
        value: "active"
      },

      { text: "Actions", value: "name", sortable: false }
    ],
    types: [
      { label: "Paid Job", key: "job" },
      { label: "Volunteering", key: "volunteer" }
    ],
    editedIndex: -1,
    editedItem: {
      active: true,
      details: "",
      id: "",
      role: "",
      title: "",
      type: ""
    },
    defaultItem: {
      active: true,
      details:
        "| Table Key | Table Value | \n| -------- | -------- |\n| Type     | Full Time      | \n| Urgency     | Immediate  | \n\n # Heading1 \n## Heading 2 \n### Heading 3 \nParagraph 1\nParagraph 2\n- list item1 \n- list item",
      id: "",
      role: "",
      title: "",
      type: "job"
    },

    rules: {
      required: value => !!value || "Required."
    },

    editorConfigs: {
      hideIcons: ["image"],
      toolbarTips: true,
      styleSelectedText: false
    }
  }),

  mounted() {
    this.editedItem = Object.assign({}, this.defaultItem);
    this.editedIndex = -1;
  },

  computed: {
    careerList() {
      return this.$store.getters.careerList;
    },
    formTitle() {
      return this.editedIndex === -1 ? "Add a new Career" : "Edit a Career";
    },
    markdown() {
      return marked(this.editedItem.details, { sanitize: true });
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  methods: {
    editItem(item) {
      this.editedIndex = this.careerList.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      confirm("Are you sure you want to delete this item?") &&
        this.$store.dispatch("deleteCareer", item);
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        this.$store.dispatch("saveCareer", this.editedItem);
      } else {
        this.$store.dispatch("addCareer", this.editedItem);
      }

      this.close();
    }
  }
};
</script>

<style>
.markdown {
  border: 1px solid #ccc;
  background: rgb(255, 255, 196);
  border-radius: 5px;
  padding: 10px;
  min-height: 100px;
}

.markdown ul,
.markdown ol {
  margin-left: 20px;
}
</style>




// WEBPACK FOOTER //
// src/pages/CareersPage.vue